import * as icc from './icc';

const Reducers = {
  ...icc,
};

export default Reducers;
